module.exports = "<canvas [id]=\"id\"></canvas>"